module.exports = __webpack_public_path__ + "static/media/user_icon_replayer_red.b369813f.svg";